import React from 'react';

const colorMap = {
	aqua: '#5dfffc',
	black: '',
	blue: '#0b5fd3',
	navy: '#0a0a33',
	sand: '#e0ddcf',
	steel: '#edf1f0',
	white: '#fff',
};

export const EarlypayLogo = ({
	className,
	height = 24,
	color = 'blue',
}: {
	className?: string;
	height?: number;
	color?: 'aqua' | 'black' | 'blue' | 'navy' | 'sand' | 'steel' | 'white';
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 2425.7 500.4"
			className={className}
			height={height}
		>
			<g
				fill={
					colorMap[color] as
						| 'aqua'
						| 'black'
						| 'blue'
						| 'navy'
						| 'sand'
						| 'steel'
						| 'white'
				}
			>
				<path d="M806.5 256.6L958.6 256.6 958.6 210.5 806.5 210.5 806.5 125.2 974.9 125.2 974.9 79.1 755.5 79.1 755.5 399.2 980.7 399.2 980.7 353.1 806.5 353.1 806.5 256.6z" />
				<path d="M1203.2 330.3v-77.2c0-20.5-1.8-46.4-15.9-65.4-14.2-19.1-38.6-28.3-74.6-28.3-59.7 0-94 27.7-99.1 80.1v.8l50.1 1.4v-.7c1.9-28.6 16.4-41.3 47.2-41.3s43.1 10.5 43.1 32.2-4.3 16-15.7 18.3l-60.5 10.8c-34.9 6.6-70.5 20.2-70.5 70.2s31.2 72.5 81.5 72.5 53.8-9.6 68.6-27.9c1.7 9.6 4.3 18 7 23l.2.4h46l-.2-.9c-6-26.2-7.2-46.1-7.2-68zm-49.2-46.4v18c0 30.7-17.5 61.6-56.6 61.6s-39.5-12.8-39.5-32.7 11.7-29.8 36.9-34.5l42-8.1c7.7-1.4 12.9-2.7 17.2-4.2zM1364.1 159.5c-35.5 0-54.5 21.4-62 32.6V164h-50.2v235.2h50.2v-114c0-52.4 20.1-77.8 61.6-77.8s17.2.7 19.3.9h.8v-45.9l-.5-.2c-5.3-1.8-12.1-2.7-19.2-2.7z" />
				<path d="M1418.9 79.1H1469.1000000000001V399.20000000000005H1418.9z" />
				<path d="M1613.5 321.8l-53-157.3-.2-.5H1506l82.4 228.2-8.5 32.8c-8.9 23.4-17.4 29.8-39.5 29.8s-17.1-.6-27.6-2.4h-.8c0-.1-.9 44.1-.9 44.1h.5c7.9 2.1 17.9 4 36.5 4 36.9 0 58.4-15.5 72-51.9L1718 165l.3-.9h-53l-51.8 157.8zM1871.1 159.5c-28.1 0-51.9 10.9-68.8 31.6V164h-50.2v332.4h50.2V376.8c15.9 17.3 39.8 26.8 67.4 26.8 62.1 0 102.3-48.5 102.3-123.5s-9.6-66.3-27.8-87.9c-18.1-21.5-43.4-32.9-73.2-32.9zm51.6 121.6c0 49.9-22.7 79.6-60.7 79.6s-61.1-29.6-61.1-79.2 23-79.2 61.6-79.2 60.2 29.4 60.2 78.7zM2191.3 330.3v-77.2c0-20.5-1.8-46.4-15.9-65.4-14.2-19.1-38.6-28.3-74.6-28.3-59.7 0-94 27.7-99.1 80.1v.8l50.1 1.4v-.7c1.9-28.6 16.4-41.3 47.2-41.3s43.1 10.5 43.1 32.2-4.3 16-15.7 18.3l-60.5 10.8c-34.9 6.6-70.5 20.2-70.5 70.2s31.2 72.5 81.5 72.5 53.8-9.6 68.6-27.9c1.7 9.6 4.2 17.9 7 23l.2.4h46l-.2-.9c-6-26.2-7.2-46.1-7.2-68zm-49.3-46.4v18c0 30.7-17.5 61.6-56.6 61.6s-39.5-12.5-39.5-32.7 11.7-29.8 36.9-34.5l42-8.1c7.7-1.4 12.9-2.7 17.2-4.2zM2372.8 164L2321 321.8l-53-157.3-.2-.5h-54.3l82.4 228.2-8.5 32.8c-8.9 23.4-17.4 29.8-39.5 29.8s-17.1-.6-27.6-2.4h-.8c0-.1-.9 44.1-.9 44.1h.5c7.9 2.1 17.9 4 36.5 4 36.9 0 58.4-15.5 72-51.9l97.9-283.6.3-.9h-53zM433.4 362.8c-36.2 20.2-76.8 32.8-126.2 18-13.8-4.1-20.1-11.2-20.1-11.2 86.4-63.6 114.4-87 144.6-141.8 6.9-12.5 15.9-36 19.4-49.9 15.4-60.8-10.8-128.8-67.3-161.1-51.5-29.4-112-17.6-158.4 15.6-54.5 39-90.6 88.5-103.8 154.1-3.2 15.7-15 80.9 7.2 147.1 24.7-11 55.2-26.5 85.5-47-10.2-34-8.4-75.9 6.2-107.8 9.5-20.8 21.6-40.9 38.5-56.5 15.5-14.3 46.4-31.7 68.9-25.1 9.8 2.9 18.3 10.1 22.7 19.3 8.7 18.4 2.6 38.9-4.6 56.6-7.8 19.1-18.7 37-31.7 53-7.1 8.8-14.6 17.2-22.6 25.1-10.4 10.3-22.8 21.1-36.1 30.3-51.6 40.3-106.9 65.4-139.3 77.9-3.8 1.5-7.7 2.9-11.5 4.3C53.1 384.1 7.2 397.4 0 399.5l60 78.6c59.3-17.2 89.8-35.4 131.7-54.3 0 0 61.4 46.6 113.8 52.7 71.1 8.2 119.4-7.6 180.9-42 18.5-10.3 37.2-23.4 54-36.3 11.9-9.1 55.7-49.7 55.9-51.4l-59-69.3c-.7.9-43.3 51.5-104 85.2z" />
			</g>
		</svg>
	);
};

export const EarlypaySymbolLogo = ({
	className,
	height = 24,
	color = 'blue',
}: {
	className?: string;
	height?: number;
	color?: 'aqua' | 'black' | 'blue' | 'navy' | 'sand' | 'steel' | 'white';
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 1317.1 1057"
			className={className}
			height={height}
		>
			<path
				d="M1317.1 766l-130.4-153.1c-1.6 1.9-95.7 113.8-229.6 188.3-80 44.5-169.5 72.5-278.7 39.8-30.5-9.1-44.5-24.8-44.5-24.8 190.8-140.4 252.6-192 319.4-313.1 15.3-27.7 35-79.6 42.8-110.2 34.1-134.4-23.8-284.5-148.7-355.7C733.8-27.8 600-1.9 497.6 71.4c-120.3 86.2-200.1 195.5-229.2 340.2-7 34.7-33.1 178.7 15.8 324.9 54.5-24.2 121.9-58.5 188.9-103.9-22.6-75-18.5-167.7 13.7-238.1 21-46 47.7-90.3 84.9-124.7 34.3-31.7 102.4-70 152.3-55.4 21.7 6.4 40.4 22.3 50.1 42.7 19.3 40.5 5.7 85.9-10.2 124.9-17.3 42.3-41.4 81.6-70 117.1-15.6 19.4-32.3 38-50 55.5-22.9 22.7-50.3 46.6-79.7 66.9-114 89.1-236.1 144.5-307.5 172-8.5 3.3-17 6.5-25.5 9.5C117.3 848.2 16 877.7 0 882.3l132.6 173.6c130.8-38 198.4-78.1 290.8-120 0 0 135.7 103 251.3 116.4 157.1 18.2 263.7-16.9 399.6-92.8 40.8-22.8 82.2-51.8 119.3-80.1 26.3-20.1 123.1-109.7 123.5-113.4z"
				fill={colorMap[color]}
			/>
		</svg>
	);
};
